// Ô nhập "Tìm menu" — luật lọc + ai thấy ô: nav-search.ts.
import { Search, X } from "lucide-react";

type Props = {
  value: string;
  onChange: (v: string) => void;
  /** Enter: mở mục đầu tiên khớp. */
  onSubmit: () => void;
};

export function NavSearchInput({ value, onChange, onSubmit }: Props) {
  return (
    <div className="relative px-3 pt-3">
      <Search
        size={14}
        aria-hidden
        className="pointer-events-none absolute left-6 top-1/2 mt-1.5 -translate-y-1/2 text-white/70"
      />
      <input
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            onSubmit();
          } else if (e.key === "Escape") {
            e.preventDefault();
            onChange("");
          }
        }}
        placeholder="Tìm menu…"
        aria-label="Tìm menu"
        autoComplete="off"
        className="h-9 w-full min-w-0 appearance-none rounded-md border border-white/25 bg-black/15 py-1 pl-8 pr-8 text-[13px] text-white placeholder:text-white/60 focus:border-white/60 focus:outline-none [&::-webkit-search-cancel-button]:hidden"
      />
      {value ? (
        <button
          type="button"
          onClick={() => onChange("")}
          aria-label="Xoá ô tìm menu"
          className="absolute right-4 top-1/2 mt-1.5 flex -translate-y-1/2 items-center justify-center rounded p-1 text-white/80 hover:text-white"
        >
          <X size={14} aria-hidden />
        </button>
      ) : null}
    </div>
  );
}
